var Curriculog = Curriculog || {};

Curriculog.ToolboxBaseView = (function ($, _, Backbone, ToolboxBaseView) {

	ToolboxBaseView = Curriculog.CurriculogView.extend({
        // if editingType is not null, then we are currently editing an item
        editingType: null,

        checkName: function () {
            // don't enable the create button if the name field is empty
            var name = $(this.el).find('#' + this.toolboxType + '-name').val()
            var createButton = $(this.el).find('.type-submit');

            if ($.trim(name).length > 0) {
                createButton.removeAttr('disabled');
            } else {
                createButton.attr('disabled', 'disabled');
            }
        },

        cancel: function () {
            this.resetTitle();
            var nameField = this.$el.find('#' + this.toolboxType + '-name');
            var createButton = this.$el.find('#' + this.toolboxType + '-create');
            var updateButton = this.$el.find('#' + this.toolboxType + '-update');

            nameField.val('');
            createButton.removeAttr('style');
            updateButton.attr('style','display:none');
            this.editingType = null;
            this.checkName();

            // reset the checkbox if we are on the role type toolbox
            if (this.toolboxType === 'role-type') {
                var committeeCheckbox = this.$el.find('#role-type-committee');
                committeeCheckbox.prop('checked', false);
                committeeCheckbox.prop('disabled', false);
            }
        },

        toTitleCase: function (str) {
            var splitStr = str.split(' ');
            var returnStr = '';

            $.each(splitStr, function (index, value) {
                returnStr += value.charAt(0).toUpperCase() + value.substr(1).toLowerCase();

                if (index !== splitStr.length) {
                    returnStr += ' ';
                }

            });

            return returnStr;
        },

        resetTitle: function () {
            var titleText = this.toolboxType.replace('-', ' ');
            titleText = this.toTitleCase(titleText);
            this.$el.find(".curriculog-types-new-type > h1").text('New ' + titleText);
        },

        edit: function (event) {
            var titleText = this.toolboxType.replace('-', ' ');
            titleText = this.toTitleCase(titleText);
            this.$el.find(".curriculog-types-new-type > h1").text('Update ' + titleText);

            var createButton = this.$el.find('#' + this.toolboxType + '-create');
            var updateButton = this.$el.find('#' + this.toolboxType + '-update');
            var nameField = this.$el.find('#' + this.toolboxType + '-name');

            createButton.attr('style','display:none');
            updateButton.prop('disabled', false);
            updateButton.removeAttr('style');

            this.editingType = this.getClickedModel(event);
            nameField.val(this.editingType.get('name'));

            if (this.toolboxType === 'role-type') {
                // reset the checkbox for the role type
                var committeeCheckbox = $(this.el).find('#role-type-committee');
                if (this.editingType.get('committee') === 1) {
                    committeeCheckbox.prop('checked', true);
                } else {
                    committeeCheckbox.prop('checked', false);
                }

                // disable the committee checkbox if the role type is not deleteable
                if (this.editingType.get('canDelete')){
                    this.$el.find('#role-type-committee').prop('disabled', false);
                } else {
                    this.$el.find('#role-type-committee').prop('disabled', 'disabled');
                }
            }
        },

        disabledDeleteButton: function (event) {
            event.preventDefault();
        },

        delete: function (event) {
            event.preventDefault();

            var view = this;
            var type = this.toolboxType.replace('-', ' ');
            var deleteItem = this.getClickedModel(event);

            new Curriculog.DeleteDialog({
                itemType: type,
                itemName: deleteItem.getSanitizedModel().get('name'),
                callback: function () {

                    deleteItem.destroy({
                        wait: true,

                        error: function () {
                            var errorText = 'An error was encountered when deleting the ' + type + '.  ';
                            errorText += 'The ' + type + ' has not been deleted.  Please try again '
                            errorText += 'or contact an administrator.';
                            view.showGrowl(errorText);
                        },
                    });
                },
            });
        },

        update: _.debounce(function () {
            if (this.editingType) {
                var view = this;
                var type = this.toolboxType.replace('-', ' ');
                var newValues = {
                    name: $(this.el).find('#' + this.toolboxType + '-name').val(),
                }

                if (type === 'role type') {
                    newValues['committee'] = +$(this.el).find('#role-type-committee').prop('checked');
                }

                this.editingType.save(newValues, {
                    wait: true,

                    error: function () {
                        var errorText = 'An error was encountered when updating the ' + type + '.  ';
                        errorText += 'Please try again or contact an administrator.';
                        view.showGrowl(errorText);
                    },

                    success: function () {
                        view.editingType = null;
                    },
                });
            }
        }, 250),

        updateList: function () {
            var makeActive = this.$el.hasClass('active');
            this.render();
            if (makeActive) {
                this.show();
            }
        },
	});
	return ToolboxBaseView;

})($, _, Backbone, Curriculog.ToolboxBaseView || {});
